import { useMutation, useQueryClient } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

import { QUERY_KEY } from './useClaimsList.query';

interface Props {
  processorId?: number;
  selectedClaims?: number[];
}

const useUnassignProcessorQuery = (onSuccess?: () => void) => {
  const queryClient = useQueryClient();
  const { mutateAsync } = useMutation(
    (props: Props) =>
      api.post(API_URL.CLAIMS_UNASSIGN_CONTACT, {
        ...(props?.processorId
          ? {
              contact_id: props?.processorId,
            }
          : {}),
        claim_ids: props?.selectedClaims,
      }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [QUERY_KEY],
        });
        if (onSuccess) onSuccess();
      },
    }
  );

  return mutateAsync;
};

export default useUnassignProcessorQuery;
